export function mapValues (object, mapping) {
  return Object.entries(object)
    .reduce((result, [key, value]) => ({ ...result, [key]: mapping(value, key, object) }), { })
}

export function uniq (comparation) {
  if (comparation) {
    if (comparation.constructor === String) {
      const key = comparation
      comparation = item => item[key]
    }

    return (original, index, array) => array.findIndex(other => comparation(other) === comparation(original)) === index
  } else {
    return (value, index, array) => array.indexOf(value) === index
  }
}

export function join (...arrays) {
  return arrays.reduce((all, array) => all.concat(array), [])
}

export function mapify (array, keyFunction, valueFunction, validation=()=>{}, startingValue={}) {
  if (!(keyFunction instanceof Function)) {
    const keyField = keyFunction
    keyFunction = item => item[keyField]
  }
  if (!(valueFunction instanceof Function)) {
    const valueField = valueFunction
    valueFunction = item => item[valueField]
  }
  return array.reduce((result, item) => {
    const key = keyFunction(item)
    const value = valueFunction(item)
    validation(key, value, item)
    return ({ ...result, [key]: value })
  }, startingValue)
}

export class ParsingError extends Error {}
